import { PrivateInterceptor } from '../../../interceptors/PrivateInterceptor'

// OBTENER LOS PERMISOS DE UN USUARIO
export const getPermisos = async(IdUser) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Users/Permisos/${IdUser}`, 'GET')
    return respuesta;
}

// OBTENER LOS PERMISOS DE UN ROL
export const getPermisosRol = async(IdRol) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Permisos/getPermisosRoles/${IdRol}`, 'GET')
    return respuesta;
}

// CAMBIAR LOS PERMISOS DE UN USUARIO
export const changePermisos = async(Permisos) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Permisos/changePermisos`, 'PUT', Permisos)
    return respuesta;
}


// CAMBIAR LOS PERMISOS DE UN ROL
export const changePermisosRol = async(Permisos) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Permisos/changePermisosRol`, 'PUT', Permisos)
    return respuesta;
}


// OBTENER LISTADO DE USUARIOS EN UN PERMISO
export const UsuariosConPermiso = async (IdMenu) => {
   const result = await PrivateInterceptor(`Base/IT/Permisos/UsuariosConPermiso`, 'POST', {IdMenu});
   return result;
}


// OBTENER LISTADO DE ROLES EN UN PERMISO
export const RolesConPermiso = async (IdMenu) => {
    const result = await PrivateInterceptor(`Base/IT/Permisos/RolesConPermiso`, 'POST', {IdMenu});
    return result;
}

